import styled from 'styled-components';
import { DeleteButton } from "assets/images";
import { Checkbox } from "antd";
import Scrollbars from "react-custom-scrollbars";


export const TickersSelectWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    :nth-child(1) {
        border-radius: 10px 10px 0 0;
    }
`;

export const ModalContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    box-shadow: 0 0 5px rgb(49 69 49 / 14%);
    border-radius: 10px;
    background-color: white;
`;

export const SelectDiv = styled(Scrollbars)``

export const NotFoundDiv = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const TopElementsDiv = styled.div`
    background-color: ${(props) => props.theme.bg.grey};
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);
    height: 45px;
    display: flex;
    flex-direction: row;
    border-radius: 10px 10px 0 0;

`;

export const TickersTitle = styled.div`
    margin: 0 0 15px;
    font-weight: bold;
    padding: 15px;
    width: 50%;
    height: 100%;
    line-height: initial;

    :nth-child(1) {
        border-right: 1px solid rgba(98, 147, 97, 0.15);
    }
`;

export const List = styled(Scrollbars)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`

export const SettingsName = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    height: 100%;
    padding-left: 15px;

    :nth-child(-n + 2) {
        border-right: 1px solid rgba(98, 147, 97, 0.15);
    }

`;

export const NameSpan = styled.span`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 150px;
`;

export const SettingsValue = styled.div`
    width: 38%;
    height: 100%;
    padding: 5px 8px 0 10px;

    :nth-child(-n + 2) {
        border-right: 1px solid rgba(98, 147, 97, 0.15);
    }
`;
export const SPSettingsValue = styled(SettingsValue)`
    width: 50%;


    :nth-child(-n + 1) {
        border-right: 1px solid rgba(98, 147, 97, 0.15);
    }
`;

export const DeleteIconArea = styled.div`
    //padding-left: 10px;
    width: 12%;

    display: flex;
    justify-content: center;
    align-items: center;
`;

export const CustomDeleteButton = styled(DeleteButton)`
    cursor: pointer;
`;

export const TickerItemDiv = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    border-bottom: 1px solid rgba(98, 147, 97, 0.15);
`;

export const CustomAntCheckbox = styled(Checkbox)`
    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: white;
        border-color: #47592F;
        border-width: 1.8px;

    }

    .ant-checkbox-checked .ant-checkbox-inner:after {
        border-color: #47592F !important;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox-checked:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
        border: 1.8px solid #47592F !important;
    }
`;









